import { render, staticRenderFns } from "./arrow-btn.vue?vue&type=template&id=4b352087&scoped=true&"
import script from "./arrow-btn.vue?vue&type=script&lang=js&"
export * from "./arrow-btn.vue?vue&type=script&lang=js&"
import style0 from "./arrow-btn.vue?vue&type=style&index=0&id=4b352087&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b352087",
  null
  
)

export default component.exports